import { render } from "./PageSwitch.vue?vue&type=template&id=5c8a6be8&scoped=true"
import script from "./PageSwitch.vue?vue&type=script&lang=js"
export * from "./PageSwitch.vue?vue&type=script&lang=js"

import "./PageSwitch.vue?vue&type=style&index=0&id=5c8a6be8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8a6be8"]])

export default __exports__